import { Injectable } from '@angular/core';
import { Entry } from 'contentful';
import { defer, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PageId } from '../utilities/pageids.enum';
import { ContentfulService } from './contentful.service';

@Injectable({
  providedIn: 'root',
})
export class TitleseoService {
  constructor(private contentful: ContentfulService) {}

  getSeoData(contentType: any, fieldsId: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          content_type: contentType,
          include: 10,
          'fields.id': fieldsId,
        })
      )
      .then(res => res.items);
  }
}
